import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

export function retornaQuantidadeDeSimOuNao(cadastros) {
  let quant_semanas_sim = 0
  let quant_semanas_nao = 0
  let quant_pre_natal_sim = 0
  let quant_pre_natal_nao = 0
  let quant_odontologia_sim = 0
  let quant_odontologia_nao = 0
  let quant_hiv_sifilis_sim = 0
  let quant_hiv_sifilis_nao = 0
  for (const item of cadastros) {
    if (item.semanas_gestacao_primeira_consulta <= 12) {
      quant_semanas_sim++
    } else {
      quant_semanas_nao++
    }
    if (item.quantidade_consultas >= 6) {
      quant_pre_natal_sim++
    } else {
      quant_pre_natal_nao++
    }
    if (item.quantidade_atendimentos_odonto >= 1) {
      quant_odontologia_sim++
    } else {
      quant_odontologia_nao++
    }
    if (
      (item.dt_ultimo_teste_hiv != null &&
        item.dt_ultimo_teste_sifilis != null) ||
      (item.dt_ultima_sorologia_hiv != null &&
        item.dt_ultima_sorologia_sifilis != null) ||
      (item.dt_ultimo_teste_hiv != null &&
        item.dt_ultima_sorologia_sifilis != null) ||
      (item.dt_ultimo_teste_sifilis != null &&
        item.dt_ultima_sorologia_hiv != null)
    ) {
      quant_hiv_sifilis_sim++
    } else {
      quant_hiv_sifilis_nao++
    }
  }
  let response = {
    quant_semanas_sim,
    quant_semanas_nao,
    quant_pre_natal_sim,
    quant_pre_natal_nao,
    quant_odontologia_sim,
    quant_odontologia_nao,
    quant_hiv_sifilis_sim,
    quant_hiv_sifilis_nao,
  }
  return response
}

export function generatePdf(cadastros, selectEquipe) {
  let title_pdf = 'Os 3 Indicadores Pré-natal'
  let titlePdfSave = utils.methods.titlePdf(
    'Os 3 Indicadores Pré-natal',
    selectEquipe.no_equipe
  )

  let description_pdf =
    'Situação dos 3 indicadores de pré-natal por gestante que vai parir no quadrimestre atual'
  let headers_pdf = [
    'NOME',
    'NASCIMENTO',
    'MÃE',
    'MA',
    '< 12 SEMANAS',
    'PRÉ-NATAL?',
    'ODONTO?',
    'HIV E SÍFILIS?',
    'GESTAÇÃO',
    'DOCUMENTO',
  ]
  var data_pdf = []
  for (let i = 0; i < cadastros.length; i++) {
    var obj = {}
    obj.no_cidadao = cadastros[i].no_cidadao
    obj.dt_nascimento = utils.methods.formatDate(cadastros[i].dt_nascimento)
    obj.no_mae = cadastros[i].no_mae
    obj.micro_area = cadastros[i].micro_area
    let semanas_gestacao_primeira_consulta =
      cadastros[i].semanas_gestacao_primeira_consulta != null
        ? cadastros[i].semanas_gestacao_primeira_consulta
        : ''
    obj.semanas =
      semanas_gestacao_primeira_consulta <= 12
        ? `Sim (${semanas_gestacao_primeira_consulta})`
        : `Não (${semanas_gestacao_primeira_consulta})`
    let quantidade_consultas =
      cadastros[i].quantidade_consultas != null
        ? cadastros[i].quantidade_consultas
        : ''
    obj.pre_natal =
      quantidade_consultas >= 6
        ? `Sim (${quantidade_consultas})`
        : `Não (${quantidade_consultas})`
    let quantidade_atendimentos_odonto =
      cadastros[i].quantidade_atendimentos_odonto != null
        ? cadastros[i].quantidade_atendimentos_odonto
        : ''
    obj.odonto =
      quantidade_atendimentos_odonto >= 1
        ? `Sim (${quantidade_atendimentos_odonto})`
        : `Não (${quantidade_atendimentos_odonto})`
    obj.hiv_sifilis =
      (cadastros[i].dt_ultimo_teste_hiv != null &&
        cadastros[i].dt_ultimo_teste_sifilis != null) ||
      (cadastros[i].dt_ultima_sorologia_hiv != null &&
        cadastros[i].dt_ultima_sorologia_sifilis != null) ||
      (cadastros[i].dt_ultimo_teste_hiv != null &&
        cadastros[i].dt_ultima_sorologia_sifilis != null) ||
      (cadastros[i].dt_ultimo_teste_sifilis != null &&
        cadastros[i].dt_ultima_sorologia_hiv != null)
        ? 'Sim'
        : 'Não'
    obj.gestacao = cadastros[i].tipo_atendimento == 1 ? 'Aberta' : 'Fechada'
    let documentoText = ''
    let lineBreak = ''
    if (cadastros[i].nu_cpf != null && cadastros[i].nu_cpf != undefined) {
      lineBreak = '\n'
      documentoText += `CPF ${cadastros[i].nu_cpf}`
    }
    if (cadastros[i].nu_cns !== null && cadastros[i].nu_cns !== undefined) {
      documentoText += `${lineBreak}CNS ${cadastros[i].nu_cns}`
    }
    obj.documento = documentoText
    data_pdf.push(obj)
  }
  let doc = new jsPDF(utils.methods.encryptionPdf())
  // cria a tabela
  let table = utils.methods.createTablePdf(data_pdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf
      )
      verticalPosition = utils.methods.bodyPdf(
        doc,
        [
          {
            label: 'Equipe',
            value: selectEquipe.no_equipe,
          },
          {
            label: 'CNES',
            value: selectEquipe.nu_cnes,
          },
          {
            label: 'INE',
            value: selectEquipe.nu_ine,
          },
        ],
        verticalPosition
      )
      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: function (data) {
          let semanas = data.row.raw[4]
          let pre_natal = data.row.raw[5]
          let odonto = data.row.raw[6]
          let hiv_sifilis = data.row.raw[7]
          if (
            semanas.includes('Sim') &&
            pre_natal.includes('Sim') &&
            odonto.includes('Sim') &&
            hiv_sifilis.includes('Sim')
          ) {
            doc.setTextColor(2, 99, 57)
          } else {
            doc.setTextColor(194, 10, 16)
          }
          // pinta a cor da descrição das colunas de preto
          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}
export const dataFields = {
  Nome: 'no_cidadao',
  'Data de nascimento': {
    field: 'dt_nascimento',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
  Mãe: 'no_mae',
  MA: 'micro_area',
}
